import { connect } from 'react-redux';
import partial from 'lodash/partial';
import RequestPaymentModal from 'account/components/payout/request_payment_modal';
import { requestPaymentRequest, fetchRequestedIfNeeded, fetchPendingAwardsIfNeeded
} from 'common/ducks/payout';

const mapStateToProps = ({ user, payout }) => {
  return {
    user: user.profile_data,
    account: (payout.accounts || []).find(a => a.is_default)
  };
}

export default connect(mapStateToProps, {
  requestPaymentRequest,
  fetchRequested: partial(fetchRequestedIfNeeded, true),
  fetchPendingAwards: partial(fetchPendingAwardsIfNeeded, true)
})(RequestPaymentModal);



// WEBPACK FOOTER //
// ./account/containers/payout/request_payment_modal.js